import $ from 'jquery';
const filesList = {
    init: () => {
        const files_list = $('.files-list');

        if(files_list.children().length > 2) {
            files_list.css('justify-content','flex-start')
        }

    }
}
export default filesList;